import { articleParagraphs } from '@/lib/blog';

// ─────────────────────────────────────────────────────────────
// Rendu du contenu d'un article de blog.
// - articles récents : HTML riche (images, vidéos, alignements)
// - anciens articles : texte simple converti en paragraphes
// ─────────────────────────────────────────────────────────────

interface ArticleContentProps {
  content: string | null;
  className?: string;
}

const HTML_RE = /<(p|div|h[1-6]|img|figure|ul|ol|blockquote|iframe|video|strong|em)\b/i;

export default function ArticleContent({ content, className }: ArticleContentProps) {
  const raw = String(content || '');

  if (HTML_RE.test(raw)) {
    return (
      <div
        className={`blog-content ${className || ''}`}
        // Contenu rédigé par le propriétaire du blog via l'éditeur intégré.
        dangerouslySetInnerHTML={{ __html: raw }}
      />
    );
  }

  const blocks = articleParagraphs(raw);
  if (blocks.length === 0) {
    return <p className={`text-sm text-foreground-500 ${className || ''}`}>Le contenu de cet article sera bientôt disponible.</p>;
  }

  return (
    <div className={`space-y-4 ${className || ''}`}>
      {blocks.map((b, i) => {
        if (b.type === 'h2') {
          return <h2 key={i} className="text-lg md:text-xl font-bold font-heading text-foreground-950 pt-2">{b.text}</h2>;
        }
        if (b.type === 'h3') {
          return <h3 key={i} className="text-base font-semibold text-foreground-900 pt-1">{b.text}</h3>;
        }
        if (b.type === 'quote') {
          return <blockquote key={i} className="border-l-2 border-accent-400 pl-4 text-sm italic text-foreground-700">{b.text}</blockquote>;
        }
        if (b.type === 'li') {
          return (
            <div key={i} className="flex items-start gap-2 text-sm text-foreground-700 leading-relaxed">
              <i className="ri-checkbox-blank-circle-fill text-[5px] mt-2 text-accent-500"></i>
              <span>{b.text}</span>
            </div>
          );
        }
        return <p key={i} className="text-sm md:text-[15px] text-foreground-700 leading-relaxed">{b.text}</p>;
      })}
    </div>
  );
}